import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { InvoiceChargeNumber } from './invoice-charge-number.model';

export const loadInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Load InvoiceChargeNumbers',
    props<{ invoiceChargeNumbers: InvoiceChargeNumber[] }>()
);

export const addInvoiceChargeNumber = createAction(
    '[InvoiceChargeNumber/API] Add InvoiceChargeNumber',
    props<{ invoiceChargeNumber: InvoiceChargeNumber }>()
);

export const upsertInvoiceChargeNumber = createAction(
    '[InvoiceChargeNumber/API] Upsert InvoiceChargeNumber',
    props<{ invoiceChargeNumber: InvoiceChargeNumber }>()
);

export const addInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Add InvoiceChargeNumbers',
    props<{ invoiceChargeNumbers: InvoiceChargeNumber[] }>()
);

export const upsertInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Upsert InvoiceChargeNumbers',
    props<{ invoiceChargeNumbers: InvoiceChargeNumber[] }>()
);

export const updateInvoiceChargeNumber = createAction(
    '[InvoiceChargeNumber/API] Update InvoiceChargeNumber',
    props<{ invoiceChargeNumber: Update<InvoiceChargeNumber> }>()
);

export const updateInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Update InvoiceChargeNumbers',
    props<{ invoiceChargeNumbers: Update<InvoiceChargeNumber>[] }>()
);

export const deleteInvoiceChargeNumber = createAction(
    '[InvoiceChargeNumber/API] Delete InvoiceChargeNumber',
    props<{ id: string }>()
);

export const deleteInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Delete InvoiceChargeNumbers',
    props<{ ids: string[] }>()
);

export const clearInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Clear InvoiceChargeNumbers'
);

export const getInvoiceChargeNumbers = createAction(
    '[InvoiceChargeNumber/API] Get InvoiceChargeNumber',
    props<{
        ScheduledStartDate: Date;
        ScheduledEndDate: Date;
        ContractListID: string;
        ContractDesc: string;
        showInactive: boolean;
    }>()
);
